import React from 'react';
import { useSelector } from 'react-redux';
import ProductGroupConfigDropdown from "../ProductGroupConfigDropdown";
import TooltipContainer from "../../components/UI/TooltipContainer";
import { Select } from 'antd';
import { useState } from 'react';
import { useGetCohortRetentionByMonthWithCategoryBreakdownQuery } from '../../redux/api/customerAnalytics';
import PlotContainer from '../PlotContainer';
import ProductGroupDropdown from '../ProductGroupDropdown';

const CategoricalRetentionWithFilters = () => {

    const [filterType, setFilterType] = useState('All');

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedConfig = useSelector((state) => state.genericReporting.selectedConfig);
    const selectedProductGroup = useSelector((state) => state.genericReporting.selectedProductGroup);

    return (
        <div className='main-content-container'>
            <div className='flexible-container flex-row'>
                <div style={{
                    'marginRight': '2vw'
                }}>
                    <h2>Filter By <TooltipContainer title='Filter By'></TooltipContainer></h2>
                    <Select style={{
                        'width': '10vw'
                    }}
                        options={
                            [
                                { label: 'All', value: 'All' },
                                { label: 'OTP', value: 'OTP' },
                                { label: 'Subscription', value: 'Subscription' }
                            ]
                        }
                        onChange={
                            (value) => {
                                setFilterType(value);
                            }
                        }
                        value={filterType}
                    ></Select>
                </div>
                <div className='flexible-container'>
                    <div>
                        <h2>Select a Configuration <TooltipContainer title='Select a Configuration'></TooltipContainer> </h2>
                        <ProductGroupConfigDropdown></ProductGroupConfigDropdown>
                    </div>
                </div>
                <div className='flexible-container'>
                    <div>
                        <h2>Select a Product Group <TooltipContainer title='Select a Product Group'></TooltipContainer> </h2>
                        <ProductGroupDropdown platform={'Shopify'}></ProductGroupDropdown>
                    </div>
                </div>
            </div>
            <div className="flexible-container" style={{
                'width': '95%',
                'height': '150vh',
            }}>
                <PlotContainer
                    useApi={useGetCohortRetentionByMonthWithCategoryBreakdownQuery}
                    useApiArgs={{ client: selectedClient, selectedConfig: selectedConfig, type: filterType, productGroup: selectedProductGroup }}
                ></PlotContainer>
            </div>
        </div>
    );
};

export default CategoricalRetentionWithFilters;